import { UserPlus } from "lucide-react";
import { ManagedPageIntro } from "@/components/managed-page-intro";
import { MembershipForm } from "@/components/membership-form";
import { PageHero } from "@/components/page-hero";
import { getPageCopy } from "@/lib/content-store";

export const dynamic = "force-dynamic";

export default async function JelentkezesPage() { const copy = await getPageCopy("jelentkezes"); return <main><PageHero eyebrow={copy.eyebrow} title={copy.title} description={copy.description} icon={UserPlus} /><ManagedPageIntro body={copy.body} /><section className="mx-auto max-w-7xl px-6 py-16 sm:py-20"><MembershipForm /></section></main>; }
